import { TCarrierStatus } from 'types'
import { TAG_STYLE } from 'transfix-ui'

export enum SortOrder {
  desc = 'desc',
  asc = 'asc',
}

export enum SortField {
  bestMatch = 'best_match',
  lastRate = 'last_rate',
  lastRan = 'last_ran',
}

export enum MatchStrategy {
  postedTrucks = 'Posted Truck',
  reservedLoads = 'Reserved Loads',
  reload = 'Reload',
  ranBackhaul = 'Ran Backhaul',
  ranHeadhaul = 'Ran Headhaul',
  ranBefore = 'Ran Before',
  laneAlert = 'Lane Alert',
  bid = 'Bid',
  postsOften = 'Posts Often',
  searched = 'Searched',
}

export enum MatchStrategyValues {
  postedTruck = 'posted_truck',
  reservedLoads = 'reserved_loads',
  reload = 'reload',
  ranBackhaul = 'ran_backhaul',
  ranHeadhaul = 'ran_headhaul',
  ranBefore = 'ran_before',
  laneAlert = 'lane_alert',
  bid = 'bid',
  postsOften = 'posts_often',
  searched = 'searched',
}

export const MATCH_STYLE = {
  [MatchStrategy.postedTrucks]: TAG_STYLE.accentGreen,
  [MatchStrategy.reservedLoads]: TAG_STYLE.accentRed,
  [MatchStrategy.reload]: TAG_STYLE.accentPurple,
  [MatchStrategy.ranBackhaul]: TAG_STYLE.accentBlue,
  [MatchStrategy.ranHeadhaul]: TAG_STYLE.accentBlue,
  [MatchStrategy.ranBefore]: TAG_STYLE.accentBlue,
  [MatchStrategy.laneAlert]: TAG_STYLE.accentRed,
  [MatchStrategy.bid]: TAG_STYLE.accentBlue,
  [MatchStrategy.postsOften]: TAG_STYLE.accentGreen,
  [MatchStrategy.searched]: TAG_STYLE.accentGreen,
}

export const MatchTypeOptions = [
  {
    label: MatchStrategy.reservedLoads,
    value: MatchStrategyValues.reservedLoads,
    selected: true,
  },
  {
    label: MatchStrategy.postedTrucks,
    value: MatchStrategyValues.postedTruck,
    selected: false,
  },
  {
    label: MatchStrategy.reload,
    value: MatchStrategyValues.reload,
    selected: true,
  },
  {
    label: MatchStrategy.ranBackhaul,
    value: MatchStrategyValues.ranBackhaul,
    selected: true,
  },
  {
    label: MatchStrategy.ranHeadhaul,
    value: MatchStrategyValues.ranHeadhaul,
    selected: true,
  },
  {
    label: MatchStrategy.ranBefore,
    value: MatchStrategyValues.ranBefore,
    selected: true,
  },
  {
    label: MatchStrategy.laneAlert,
    value: MatchStrategyValues.laneAlert,
    selected: true,
  },
]

export interface IMatch {
  strongestMatch: MatchStrategy
  carrierId: string
  carrierName: string
  carrierState: TCarrierStatus
  mcNumber: string
  headquarter: string
  powerUnits: number
  trailerCount: number
  canBeer: boolean
  carrierProfile: string
  reservedLane: boolean
  reloads: boolean
  ranBackhaul: boolean
  ranHeadhaul: boolean
  laneWithRadiusHistory: boolean
  laneAlert: boolean
  bidHistory: boolean
  availableTruck: boolean
  laneSearchHistory: boolean
  referenceShipmentIds: number[]
  referenceTruckIds: number[]
  totalRan: string
  lastRate: string
  lastRan: string
  metadata: {
    deliveryCityState: string
    dispatcherEmail: string
    dispatcherId: string
    dispatcherName: string
    dispatcherPhone: string
    dispatcherPhoneExt: string
    lastShipmentId: string
    pickupCityState: string
    destinationLocations?: string
    externallyCreatedAt?: string
    originDeadhead?: {
      miles: number
      method: string
    }
    recipients?: IMatchRecipients[]
  }
}

export interface IMatchRecipients {
  id: number
  firstName: string
  lastName: string
  phone: string
  phoneExt: string
  email: string
}

export interface ICarrierMatchesState {
  loading: boolean
  error: string
  data: {
    entities?: { matches?: { [carrierId: number]: IMatch } }
    result?: number[]
  }
  totalCount: number
  currentFilters: Partial<ICarrierMatchesFilters>
}

export interface ICarrierMatchesFilters {
  shipmentId: number
  originRadiusMiles?: number
  destinationRadiusMiles?: number
  bookedWithIds?: string
  filteredStrategies?: MatchStrategyValues[]
  lookbackDate?: string
  pickupStateCode?: string
  deliveryStateCode?: string
  sortOrder?: SortOrder
  sortField?: SortField
  pageCount?: number
  pageSize?: number
}
